import { StepInput } from '../../../../shared/StepInput'
import { useRecurrenceEndOccurrenceProps } from './useRecurrenceEndOccurrenceProps'

type RecurrenceEndOccurrencePickerProps = {
  testId?: string
  requiredRecurrences: number
}

export function RecurrenceEndOccurrencePicker(props: RecurrenceEndOccurrencePickerProps) {
  const { requiredRecurrences, testId = 'RecurrenceEndOccurrencePicker' } = props
  const { label, info, value, onChange } = useRecurrenceEndOccurrenceProps(requiredRecurrences)

  return (
    <StepInput
      label={label}
      info={info}
      value={value}
      onChange={onChange}
      testId={testId}
      trackId={testId}
    />
  )
}
